import { useGetContentItemByGuidQuery } from '@api/api';
import { ContentItemRequest } from '@api/types';
import { LoadingError } from '@components';
import React from 'react';

export interface ContentItemLoaderProps {
  guid?: string;
  component: React.FC<any>;
}

export const ContentItemLoader = ({ guid, component }: ContentItemLoaderProps) => {
  const request: ContentItemRequest = { guid };
  const response = useGetContentItemByGuidQuery(request);
  const { isError } = response;
  return (
    <>
      {!isError && React.createElement(component, { ...response })}
      {isError && <LoadingError />}
    </>
  );
};
